export default __webpack_public_path__ + "static/media/logo_new.f5c7e3c1.png";